import { actionCopyIt } from "./actionCopy";

export const analyticsCopyIt = {
    navTitle: "Analisi",
    navDescription: "Analizzi i dati dei Suoi pazienti",
    events: "Eventi",
    outcomes: "Risultati",
    rawData: "Dati grezzi",
    searchPatientsPlaceholder: "Cercare pazienti...",
    searchPatientsAria: "Cercare pazienti per nome o altri campi",
    clearPatientSearchAria: "Cancellare la ricerca dei pazienti",
    editWithAiPlaceholder: "Modificare con l'IA",
    editWithAiAria: "Modificare con l'IA",
    stopAiEditAria: "Interrompere l'IA",
    downloadCsv: "Scaricare il CSV",
    preparingCsv: "Preparazione del CSV...",
    downloadSas: "Esporta per SAS",
    preparingSas: "Preparazione del SAS...",
    sasExportHelp:
        "Scarica i tuoi dati di analisi per SAS. Studio e date sono facoltativi: lasciali vuoti per esportare tutto ciò che puoi vedere. Le colonne usano gli OID delle variabili e le risposte codificate, oppure il testo della domanda quando un modulo non ha ancora OID.",
    sasStudy: "Studio",
    sasFrom: "Dal",
    sasTo: "Al",
    sasExport: "Esporta",
    sasDateOrder: "La data di inizio deve essere uguale o precedente alla data di fine.",
    sasFailed: "L'esportazione SAS non è riuscita. Riprova.",
    sasForbidden: "Non hai l'autorizzazione per esportare questo studio.",
    sasUnmapped: "Non ci sono domande da esportare per questa selezione.",
    sasEmpty: "Nessuna voce per questo studio e periodo.",
    sasRetry: "Riprova",
    sasAllStudies: "Tutti gli studi",
    sasAnyDate: "Qualsiasi data",
    sasClearDate: (label: string) => `Cancella la data «${label.toLowerCase()}»`,
    sasProgress: (loaded: number, total: number) => `Caricamento dei diari: ${loaded} di ${total}`,
    columns: actionCopyIt.columns,
    columnVisibilityDiffers: "La visibilità delle colonne differisce dal valore predefinito",
    filter: actionCopyIt.filter,
    addFilter: "Aggiungi filtro",
    filtersFor: (name: string) => `Filtri per « ${name} »`,
    activeFilters: (count: number) => `${count} filtr${count === 1 ? "o attivo" : "i attivi"}`,
    edit: actionCopyIt.edit,
    done: actionCopyIt.done,
    shared: "Condiviso",
    noData: "Nessun dato",
    noScoresForFilter: "Nessun punteggio per questa combinazione di filtri",
    failedToLoadEvents: "Caricamento degli eventi non riuscito",
    noEvents: "Nessun evento",
    patients: "Pazienti",
    gender: "Sesso",
    age: "Età",
    area: "Area",
    diaryId: "ID del diario",
    patient: "Paziente",
    date: "Data",
    optionsFor: (name: string) => `Opzioni per ${name}`,
    shiftLeft: "Spostare a sinistra",
    pieChart: "Grafico a torta",
    donutChart: "Grafico ad anello",
    barChart: "Grafico a barre",
    lineChart: "Grafico a linee",
    sparkCharts: "Grafici sparkline",
    statsTable: "Tabella statistica",
    statsTableSpark: "Tabella statistica + sparkline",
    table: "Tabella",
    stats: "Statistiche",
    timepointTable: "Tabella per scadenza",
    histogram: "Istogramma",
    outliers: "Valori anomali",
    changeFromBaseline: "Variazione rispetto all'inclusione",
    cumulativeEnrolment: "Inclusioni cumulative",
    engagementRate: "Completamento tra chi ha iniziato",
    followUpCompletion: "Completamento del follow-up",
    engagementHint:
        "Quota dei diari iniziati che hanno completato ogni follow-up. Il valore iniziale è il primo questionario, quindi dovrebbe essere vicino al tasso di avvio del diario. Un completamento in ritardo conta comunque come completato. I diari mai iniziati sono esclusi, così come le finestre ancora aperte.",
    engagementPercentCompleted: "Percentuale completata",
    engagementRateHint:
        "Dei pazienti che hanno iniziato il questionario: completato entro un mese, solo alcune domande entro un mese, oppure non terminato entro un mese. I pazienti che non hanno mai iniziato non sono inclusi.",
    engagementComplete: "In tempo",
    engagementPartial: "Parziale entro 1 mese",
    engagementNotStarted: "Non iniziato",
    engagementNotWithin: "Non entro 1 mese",
    engagementDue: "Da fare",
    engagementStarted: "Iniziato",
    engagementOfPatientsDue: "Percentuale di pazienti con follow-up da fare",
    engagementOfPatientsStarted: "Percentuale di pazienti che hanno iniziato",
    engagementOfDue: (completed: number, due: number) => `${completed} su ${due} da fare`,
    engagementLate: "In ritardo",
    engagementMissed: "Mancato",
    engagementCompletion: "Completamento",
    engagementAllPatients: "Tutti i pazienti",
    engagementPatientsDue: (n: number) => `${n} da fare`,
    engagementHeatmapSplitHint:
        'Scelga "Split by" nelle impostazioni del grafico per confrontare sedi, etichette o clinici.',
    engagementDotSize: "La dimensione del punto indica quanti pazienti avevano un follow-up da fare.",
    engagementDispositionHint:
        "Ogni paziente conta una volta per finestra clinica. I follow-up aperti sono esclusi finché non sono completati o finché la finestra consentita non si chiude.",
    engagementTimingHint:
        "Giorni tra l'invio e l'orario previsto. Il punto è la differenza mediana e la barra è il 50% centrale.",
    engagementTimingRangeHint:
        "Lo zero è l'orario previsto. Un numero positivo indica i giorni di ritardo e un numero negativo i giorni di anticipo. In tempo significa entro la finestra consentita da entrambi i lati di quell'orario: l'intervallo fino al follow-up successivo, da 1 giorno fino a 21 giorni.",
    engagementOnTimeCount: (onTime: number, completed: number) => `${onTime} su ${completed} in tempo`,
    engagementTimingWindowColumn: "Finestra consentita",
    engagementDayWindow: (min: number, max: number) =>
        min === max ? `Finestra di ${min} giorni` : `Finestra da ${min} a ${max} giorni`,
    engagementTimingWindowSummary: (min: number, max: number) =>
        min === max ? `Entro una finestra di ${min} giorni` : `Entro una finestra da ${min} a ${max} giorni`,
    engagementWithinWindowCount: (onTime: number, completed: number, min: number, max: number) =>
        min === max
            ? `${onTime} su ${completed} entro una finestra di ${min} giorni`
            : `${onTime} su ${completed} entro una finestra da ${min} a ${max} giorni`,
    engagementOutsideDayWindow: (n: number, min: number, max: number) =>
        min === max
            ? `${n} fuori dalla finestra di ${min} giorni`
            : `${n} fuori dalla finestra da ${min} a ${max} giorni`,
    engagementOutsideWindow: (n: number, window?: string) =>
        window ? `${n} fuori dalla finestra (${window})` : `${n} fuori dalla finestra`,
    engagementWindowDays: (min: number, max: number) =>
        min === max ? `±${min} ${min === 1 ? "giorno" : "giorni"}` : `±${min} a ${max} giorni`,
    engagementOutsideWindowColumn: "Fuori dalla finestra",
    engagementGapDays: (days: number) => {
        const rounded = Math.round(days * 10) / 10;
        const unit = Math.abs(rounded) === 1 ? "giorno" : "giorni";
        if (rounded === 0) return `0 ${unit}`;
        return `${rounded > 0 ? "+" : ""}${rounded} ${unit}`;
    },
    engagementTimingAxisDays: (days: number) => {
        if (days === 0) return "0";
        const unit = Math.abs(days) === 1 ? "giorno" : "giorni";
        return `${days > 0 ? "+" : ""}${days} ${unit}`;
    },
    engagementTimingEmpty: "Nessun follow-up programmato e completato ha dati temporali",
    engagementEarlier: "In anticipo",
    engagementScheduled: "Programmato",
    engagementLater: "In ritardo",
    engagementMedian: "Mediana",
    engagementCompleted: "Completato",
    engagementMiddle50: "50% centrale",
    engagementCompletedCount: (n: number) => `${n} completati`,
    engagementMetrics: "Indicatori di partecipazione",
    engagementMetricsHint:
        "Il completamento degli inserimenti e dei diari usa i questionari dei pazienti sui diari già iniziati. Il conteggio dei diari completati è calcolato su quei diari iniziati. I moduli del clinico sono esclusi.",
    engagementMetric: "Indicatore",
    engagementRateColumn: "Tasso",
    engagementCount: "Conteggio",
    engagementOnTimeRate: "Tasso in tempo",
    engagementDiaryStartRate: "Tasso di avvio del diario",
    engagementEntryCompletionRate: "Tasso di completamento degli inserimenti",
    engagementDiaryCompletionRate: "Tasso di completamento del diario",
    engagementDiariesStarted: (completed: number, due: number) => `${completed} su ${due} diari iniziati`,
    engagementEntriesCompleted: (completed: number, due: number) => `${completed} su ${due} inserimenti completati`,
    engagementDiariesCompleted: (completed: number, due: number) => `${completed} su ${due} diari completati`,
    engagementWindows: {
        baseline: "Valore iniziale",
        w6: "Fino a 6 settimane",
        m3: "Da 6 settimane a 3 mesi",
        m6: "Da 3 a 6 mesi",
        m12: "Da 6 a 12 mesi",
        m12plus: "Oltre 12 mesi",
    } as Record<string, string>,
    engagementAllCompleted: "Tutti completati",
    engagementSomeCompleted: "Alcuni completati",
    engagementNoneStarted: "Nessun follow-up è stato ancora iniziato",
    engagementOnTime: "In tempo",
    engagementUnderMonth: "Meno di 1 mese di ritardo",
    engagementOverMonth: "Più di 1 mese di ritardo",
    engagementEmpty: "Nessun follow-up programmato è ancora da fare",
    engagementPatient: "Paziente",
    engagementClinician: "Clinico",
    engagementCohort: "Coorte",
    engagementByLabel: "Etichetta del diario",
    engagementByClinician: "Clinico",
    engagementByTracker: "Monitoraggio",
    engagementFollowUp: "Follow-up",
    engagementFollowUpGrain: "Tempistica",
    engagementFollowUpAbsolute: "Assoluto",
    engagementFollowUpGrouped: "Raggruppato",
    engagementFollowUpDaily: "Giornaliero",
    engagementFollowUpWeekly: "Settimanale",
    engagementFollowUpMonthly: "Mensile",
    engagementFollowUpQuarterly: "Trimestrale",
    engagementFollowUpYearly: "Annuale",
    engagementFollowUpDays: "Giorni",
    engagementFollowUpWeeks: "Settimane",
    engagementFollowUpMonths: "Mesi",
    engagementFollowUpYears: "Anni",
    engagementFollowUpAbsoluteHint: "Ogni follow-up resta un punto a sé, nell'ordine del calendario.",
    engagementFollowUpGroupedHint:
        "Raggruppato mostra Mese 0, Mese 1, Mese 2. Il Mese 0 corrisponde ai primi 30 giorni.",
    engagementFollowUpStep: (grain: "day" | "week" | "month" | "quarter" | "year", index: number) => {
        const label =
            grain === "day"
                ? "Giorno"
                : grain === "week"
                  ? "Settimana"
                  : grain === "month"
                    ? "Mese"
                    : grain === "quarter"
                      ? "Trimestre"
                      : "Anno";
        return `${label} ${index}`;
    },
    engagementFollowUpGrainHint: (grain: "day" | "week" | "month" | "quarter" | "year") => {
        if (grain === "day")
            return "Giornaliero mostra Giorno 0, Giorno 1, Giorno 2. Il Giorno 0 è il giorno dell'intervento.";
        if (grain === "week")
            return "Settimanale mostra Settimana 0, Settimana 1, Settimana 2. La Settimana 0 corrisponde ai primi 7 giorni.";
        if (grain === "quarter")
            return "Trimestrale mostra Trimestre 0, Trimestre 1, Trimestre 2. Il Trimestre 0 corrisponde ai primi 90 giorni.";
        if (grain === "year") return "Annuale mostra Anno 0, Anno 1, Anno 2. L'Anno 0 è il primo anno.";
        return "Mensile mostra Mese 0, Mese 1, Mese 2. Il Mese 0 corrisponde ai primi 30 giorni.";
    },
    engagementGroupAria: "Dettaglio della partecipazione",
    engagementOf: (completed: number, due: number) => `${completed} su ${due}`,
    unlabelled: "Senza etichetta",
    unassigned: "Non assegnato",
    timepoint: "Scadenza",
    ageBracket: "Fascia d'età",
    label: "Etichetta del diario",
    sex: "Sesso",
    anatomicArea: "Area anatomica",
    event: "Evento",
    form: "Modulo",
    averageAge: "Età media",
    patientCountsByAgeBracket: "Numero di pazienti per fascia d'età",
    ageDistribution: "Distribuzione per età",
    chartOfGender: (chart: string) => `${chart} per sesso`,
    patientCountsByGender: "Numero di pazienti per sesso",
    totalPatients: "Totale pazienti",
    meanField: (field: string) => `Media: ${field}`,
    formStats: (form: string) => `Statistiche: ${form}`,
    tableOf: (dataset: string) => `Tabella: ${dataset}`,
    sparkChartsOf: (form: string) => `Grafici sparkline: ${form}`,
    statsTableOf: (form: string) => `Tabella statistica: ${form}`,
    statsTableByTimepoint: (form: string) => `Tabella statistica per scadenza: ${form}`,
    statsTableSparkOf: (form: string) => `Tabella statistica + sparkline: ${form}`,
    statsTableSparkByTimepoint: (form: string) => `Tabella statistica + sparkline per scadenza: ${form}`,
    lineChartOverTime: (form: string) => `Grafico a linee di ${form} nel tempo`,
    byTimepoint: (form: string) => `${form} per scadenza`,
    histogramOf: (subject: string) => `Istogramma: ${subject}`,
    outliersOf: (subject: string) => `Valori anomali: ${subject}`,
    ageOutliers: "Valori anomali dell'età",
    outlierChart: {
        allPatients: "Tutti i pazienti",
        noOutliers: "Nessun valore oltre i limiti.",
        rule: "I punti a più di 1,5 × IQR fuori dal box sono segnalati. Il box copre la metà centrale delle risposte e la linea è la mediana.",
        flagged: (count: number) => `${count} segnalati`,
        patient: "Paziente",
        timepoint: "Momento",
        value: "Valore",
        range: "Intervallo atteso",
        more: (count: number) => `e altri ${count}`,
        between: (low: string, high: string) => `${low} a ${high}`,
        organisation: "Organizzazione",
        createdBy: "Creato da",
        startDate: "Inizio del diario",
        private: "Privato",
        ageYears: (count: number) => `${count} anni`,
        responses: "Risposte",
        mean: "Media",
        flaggedLabel: "Segnalati",
        rangeJoin: "a",
        tooFew: "Troppe poche risposte per segnalare valori anomali",
    },
    previousTreatments: (form: string) => `Trattamenti precedenti · ${form}`,
    patientCountsBy: (group: string) => `Numero di pazienti per ${group}`,
    barChartOfBy: (subject: string, group: string) => `Grafico a barre: ${subject} per ${group}`,
    chartOf: (chart: string, subject: string) => `${chart}: ${subject}`,
    chartOfBy: (chart: string, dataset: string, field: string) => `${chart}: ${dataset} per ${field}`,
    bySuffix: (title: string, split: string) => `${title} per ${split}`,
    changeFromBaselineSubject: (subject: string) => `Variazione rispetto all'inclusione · ${subject}`,
    lsmeanChange: (subject: string) => `Variazione della media dei minimi quadrati · ${subject}`,
    percentOfMax: (subject: string) => `% del massimo · ${subject}`,
    percentChangeFromBaseline: (subject: string) => `% di variazione rispetto all'inclusione · ${subject}`,
    score: "Punteggio",
    shiftRight: "Spostare a destra",
    rename: actionCopyIt.rename,
    duplicate: actionCopyIt.duplicate,
    share: actionCopyIt.share,
    delete: actionCopyIt.delete,
    cancel: actionCopyIt.cancel,
    addView: "Aggiungere una vista",
    addViewDescription: "Scelga prima una cruscotto di grafici o un foglio di dati grezzi.",
    addViewStepOf: (step: number, total: number) => `Passaggio ${step} di ${total}`,
    addViewStepTypeTitle: "Che tipo di vista?",
    addViewStepTypeDescription:
        "Scelga una cruscotto di grafici o un foglio di dati grezzi. Potrà quindi copiare le impostazioni e consultare l'IA.",
    addViewStepSetupTitle: "Copiare impostazioni o consultare l'IA",
    addViewStepSetupDescription:
        "Facoltativo. Copi i filtri da un'altra scheda, descriva ciò che desidera, oppure entrambe le cose.",
    addViewBack: "Indietro",
    addViewAiLabel: "Chiedere all'IA",
    addViewAiPlaceholderCharts: "Facoltativo: descriva i grafici desiderati, ad es. WOMAC nel tempo per età",
    addViewAiPlaceholderData:
        "Facoltativo: descriva i filtri, ad es. diari del ginocchio di pazienti di età superiore a 60 anni",
    copySettingsFrom: "Copiare le impostazioni da",
    none: actionCopyIt.none,
    charts: "Grafici",
    data: "Dati",
    chartsDescription: "Widget, tendenze e statistiche di riepilogo",
    dataDescription: "Foglio di calcolo delle righe pazienti e dei punteggi",
    createChartsView: "Creare una vista grafici",
    createDataView: "Creare una vista dati",
    refreshAria: "Aggiornare i dati di analisi",
    addWidget: "Aggiungere un widget",
    addWidgetFor: (name: string) =>
        `Scelga un modulo, un campo facoltativo e la modalità di visualizzazione per « ${name} ».`,
    noWidgetsOnTab: "Nessun widget in questa scheda al momento.",
    useAddWidgetToChart: (label: string) =>
        `Usi « Aggiungere un widget » sopra per rappresentare graficamente dati reali ${label}.`,
    diaryFallback: "diario",
    failedToLoadAnalytics: "Caricamento dei dati di analisi non riuscito",
    failedToLoadData: "Caricamento dei dati non riuscito",
    failedToLoadPatientData: "Caricamento dei dati pazienti non riuscito. Aggiorni per riprovare.",
    loadingPatients: "Caricamento dei pazienti...",
    loadingAnalytics: (label: string) => `Caricamento dei dati ${label}...`,
    analyticsFallback: "di analisi",
    fieldFallback: "Campo",
    /** Under the total in the middle of a form donut. */
    donutResponses: "risposte",
    noWidgetsYet: "Nessun widget al momento. Ne aggiunga uno dalla tavolozza oppure lo chieda all'assistente IA.",
    noWidgetsConfigured: "Nessun widget configurato per questa vista.",
    clearFilters: "Cancellare i filtri",
    deleteViewTitle: "Eliminare la vista?",
    deleteViewDescription: (name: string) =>
        `Questa operazione eliminerà definitivamente « ${name} » e i relativi widget. Questa azione è irreversibile.`,
    showingRangeOf: (start: string, end: string, total: string, noun: string) =>
        `Visualizzazione da ${start} a ${end} di ${total} ${noun}`,
    rowSingular: "riga",
    rowPlural: "righe",
    diarySingular: "diario",
    diaryPlural: "diari",
    noPatientsMatch: (query: string) => `Nessun paziente corrisponde a « ${query} »`,
    noPatientsMatchFilters: "Nessun paziente corrisponde ai filtri attuali",
    searchColumnsPlaceholder: "Cercare colonne...",
    searchColumnsAria: "Cercare colonne",
    visibleColumns: "Colonne visibili",
    showAll: "Mostrare tutto",
    hideAll: "Nascondere tutto",
    eventsCount: "eventi",
    acrossDiaries: (count: number) => `Su ${count} ${count === 1 ? "diario" : "diari"}`,
    eventPrefix: (label: string) => `Evento · ${label}`,
    chartSettings: "Impostazioni del grafico",
    severalDataTabsHint:
        "Ha già diverse schede di dati - valuti di modificare i filtri o le colonne di una scheda esistente.",
    chartN: (n: number) => `Grafico ${n}`,
    dataN: (n: number) => `Dati ${n}`,
    showingColumnsOf: (visible: string, total: string) => `Visualizzazione di ${visible} colonne su ${total}`,
    noColumnsMatch: (query: string) => `Nessuna colonna corrisponde a « ${query} »`,
    filterCategories: {
        mine: "Il mio ruolo",
        demographic: "Dati demografici",
        label: "Etichetta del diario",
        org: "Organizzazione",
        form: "Modulo",
        event: "Evento",
        status: "Stato del diario",
    },
    filterAnnotations: {
        mine: "Diari in cui ha uno di questi ruoli.",
        label: "Diari con una di queste etichette.",
        org: "Diari in una di queste organizzazioni.",
        status: "Diari con uno di questi stati.",
    },
    filteredBy: "Filtrato per",
    sexValues: { Female: "Donna", Male: "Uomo", Other: "Sconosciuto" },
    rawCellExplanations: {
        genderInferred:
            "Il sesso è dedotto dal titolo presente nel nome del paziente (ad es. Sig., Sig.ra). Modifichi la colonna Nome per cambiarlo.",
        genderPrivate:
            "Il sesso è una caratteristica di coorte dedotta dal titolo (ad es. Sig., Sig.ra). Il nome resta privato per il Suo livello di accesso.",
        patientNamePrivate: "Il nome del paziente è privato per il Suo livello di accesso.",
        patientNameHidden: "Il nome del paziente è nascosto senza accesso ai dati identificativi.",
        dobPrivate: "La data di nascita è privata per il Suo livello di accesso.",
        ageEditable:
            "Età alla data di inizio del diario, calcolata dalla data di nascita - e non l'età attuale del paziente. Modifichi la data di nascita per cambiarla.",
        agePrivate:
            "Età alla data di inizio del diario, calcolata dalla data di nascita - e non l'età attuale del paziente. La data di nascita resta privata per il Suo livello di accesso.",
        ageReadonly:
            "Età alla data di inizio del diario, calcolata dalla data di nascita - e non l'età attuale del paziente.",
        sideDerived:
            "Il lato a cui si riferiscono i questionari di questa riga. Scelga « Entrambi » se sono interessati entrambi i lati.",
        noQuestionnaireSide: "Nessun questionario in questa riga per cui impostare un lato.",
        noEditableEvent: "Nessun evento modificabile in questo diario.",
        unsupportedEventValue: "Questo valore non è supportato dal modulo di modifica dell'evento.",
        noEventDate: "Nessuna data dell'evento da modificare in questo diario.",
        noEditableArea: "Nessun evento modificabile fornisce questa area.",
        shockwaveProcedure: "Le onde d'urto costituiscono il tipo di intervento, non un dettaglio modificabile.",
        noEditableProcedure: "Nessun evento modificabile fornisce questo intervento.",
        ageDerived:
            "Età alla data di inizio del diario, calcolata dalla data di nascita. Non è l'età attuale del paziente.",
        durationDerived: "Calcolata tra la data di inizio del diario e oggi.",
        ageAtEventDerived: (event: string) => `Calcolato dalla data di nascita e dalla data più antica di ${event}.`,
        noTracker: "Nessun monitoraggio in questa scadenza per questo diario.",
        noSideTracker: (side: string) => `Nessun monitoraggio (${side}) in questa scadenza per questo diario.`,
        notOnSchedule: "Questa scadenza non è presente nel calendario di questo monitoraggio.",
        editFromDiary: "Modifica questa risposta dal diario del paziente.",
        notOnSideSchedule: (side: string) =>
            `Questa scadenza non è presente nel calendario del monitoraggio (${side}).`,
        multipleEventRows: (event: string) =>
            `Questo evento (${event}) contiene più righe di dettagli. Lo modifichi dal diario del paziente per non sostituire gli altri dettagli.`,
        multipleEvents: (event: string) =>
            `Più eventi (${event}) contribuiscono a questa cella. Li modifichi dal diario del paziente.`,
        multipleDates: (event: string) =>
            `Più date (${event}) contribuiscono a questa cella. Le modifichi dal diario del paziente.`,
        editDobHelper: "L'età all'inizio del diario è calcolata da questa data di nascita.",
        editEventDateHelper: (event: string) => `Modificare la data (${event}).`,
    },
    eventDatasetLabels: {
        injection: "Iniezioni",
        surgery: "Operazioni",
        shockwave: "Onde d'urto",
        product: "Prodotti",
        education: "Consulti",
        medication: "Farmaci",
    } as Record<string, string>,
    rawSideValues: { left: "sinistro", right: "destro", both: "entrambi", middle: "mediano" } as Record<string, string>,
    showDetailsAria: "Mostrare i dettagli",
    widgetTypes: {
        stat: "Scheda statistica",
        bar: "Barre",
        histogram: "Istogramma",
        outliers: "Valori anomali",
        donut: "Anello",
        pie: "Settori",
        line: "Linea/area",
        spark: "Grafici sparkline",
        statsTable: "Tabella statistica",
        statsTableSpark: "Tabella statistica + sparkline",
        timepoints: "Tabella per scadenza",
        table: "Tabella",
        enrolment: "Inclusioni cumulative",
        engagement: "Completamento del follow-up",
        engagementTable: "Tabella dei follow-up",
        engagementRate: "Tra chi ha iniziato",
        engagementDisposition: "Situazione del paziente",
        engagementTiming: "Tempistica rispetto al calendario",
        engagementRetention: "Curva di permanenza",
        engagementKpi: "Numeri principali",
        engagementHeatmap: "Mappa di calore per suddivisione",
        engagementDots: "Grafico a punti",
    },
    valueTransforms: {
        absolute: "Assoluto",
        changeFromBaseline: "Variazione rispetto all'inclusione",
        lsmeanChange: "Variazione della media dei minimi quadrati",
        percentOfMax: "% del massimo",
        percentChangeFromBaseline: "% di variazione rispetto all'inclusione",
    },
    summaryTable: {
        unknownForm: "Modulo sconosciuto",
        noEntries: "Nessun inserimento",
        metric: "Indicatore",
        distribution: "Distribuzione",
        boxPlot: "Diagramma a scatola",
        mean: "Media",
        median: "Mediana",
        mode: "Moda",
        sd: "DS",
        ci: "IC al 95%",
        frequency: "Frequenza",
        value: "Valore",
        count: "Conteggio",
        percent: "%",
        indicator: "Indicatore",
        proportion: "Proporzione",
        entries: "Inserimenti",
        yes: "Sì",
        no: "No",
    },
    rawColumnGroups: {
        Patient: "PAZIENTE",
        INJECTION: "INIEZIONE",
        SURGERY: "OPERAZIONE",
        SHOCKWAVE: "ONDE D'URTO",
        PRODUCT: "PRODOTTO",
        CONSULTATION: "CONSULTO",
    } as Record<string, string>,
    rawFieldLabels: {
        Date: "Data",
        Substance: "Sostanza",
        Area: "Area",
        Site: "Sede",
        Side: "Lato",
        Dose: "Dose",
        Type: "Tipo",
        Procedure: "Intervento",
        Product: "Prodotto",
        Topic: "Argomento",
        "Provided by": "Fornito da",
        "Delivered by": "Eseguito da",
        "Referring clinician": "Medico inviante",
        "Injecting clinician": "Clinico che esegue l'iniezione",
        "Operating clinician": "Clinico operatore",
        "Shockwaving clinician": "Clinico che esegue le onde d'urto",
    } as Record<string, string>,
    rawColumnLabels: {
        diary_id: "ID del diario",
        patient_name: "Nome",
        date_of_birth: "Data di nascita",
        age: "Età all'inizio",
        gender: "Sesso",
        organisation: "Organizzazione",
        side: "Lato",
        area: "Area",
        procedure: "Intervento",
    } as Record<string, string>,
    scoreUnavailable: "Non disponibile",
    scoreAdd: "Aggiungere un punteggio",
    scoreNotDueYet: "Non ancora da fare",
    scoreLate: "In ritardo",
    scoreClickToAddTooltip: "Faccia clic sulla cella per aggiungere un punteggio",
    scoreLateTooltip: "Questa scadenza è in ritardo. Faccia clic sulla cella per aggiungere un punteggio.",
    scoreNotDueTooltip: "Questa scadenza non è ancora da fare. Faccia clic sulla cella per aggiungere un punteggio.",
    scoreNoTrackerTooltip: "Nessun monitoraggio in questa scadenza per questo diario.",
    editScore: "Modificare il punteggio",
    clearScore: "Cancellare",
    decreaseScoreAria: "Diminuire il punteggio",
    increaseScoreAria: "Aumentare il punteggio",
    scoreRange: (min: number, max: number) => `Intervallo ${min} - ${max}`,
    scoreMin: (min: number) => `Min ${min}`,
    scoreMax: (max: number) => `Max ${max}`,
    confidential: "Riservato",
    confidentialAria: "Dati del paziente riservati. Mostrare il motivo.",
    thisTimepoint: "Questa scadenza",
    dueDate: (date: string) => `Da fare il ${date}`,
    enteredDate: (date: string) => `Inserito il ${date}`,
    entryNotEnteredYet: "Non ancora inserito",
    timepointHasRecordedScore: (point: string) => `${point} ha un punteggio registrato.`,
    timepointDates: (point: string, dates: string) => `${point}: ${dates}.`,
    timepointNoTracker: (point: string) =>
        `${point} non ha un monitoraggio in questo diario, pertanto non è possibile aggiungere un punteggio.`,
    clickToAddScore: "Faccia clic per aggiungere un punteggio.",
};
